import { PAGE_DOMAIN, VTCLOUD_CLIENT_ID, VTCLOUD_IAM_URL } from "constants/api";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { clearTokens } from "utils/cookies";
import { base64UrlEncode, generateCodeVerifier, sha256 } from "utils/helpers";
import { v4 as uuid } from "uuid";
import { useAuthFlow } from './AuthFlowContext';

const useViettelCloudIAM = (props) => {
    const state = uuid()

    const [config, setConfig] = useState({
        authorization_endpoint: VTCLOUD_IAM_URL + "/realms/viettel-cloud/protocol/openid-connect/auth"
    })
    const [configReady, setConfigReady] = useState(false)
    const { updateSSOFlow } = useAuthFlow()

    const [codeVerifier, setCodeVerifier] = useState(null)
    const [codeVerifierSha, setCodeVerifierSha] = useState(codeVerifier)
    const [challengeMethod, setChallengeMethod] = useState('plain')
    const [codeChallenge, setCodeChallenge] = useState('')
    const [url, setURL] = useState('')
    const [urlReady, setURLReady] = useState(false)
    const [loginState, setLoginState] = useState(false)
    const [params] = useSearchParams();
    const isProvideService = params.get('isProvideService');

    const fetchConfig = async () => {
        try {
            const response = await fetch(VTCLOUD_IAM_URL + "/realms/viettel-cloud/.well-known/openid-configuration")
            const configData = await response.json()
            setConfig(configData)
            setConfigReady(true)
        } catch (error) {
            setConfigReady(true)
        }
    }

    const login = () => {
        fetchConfig()
        clearTokens()
        setLoginState(true)
        localStorage.setItem("checkEventPopupByUser", 1);
    }

    useEffect(() => {
        const fetchConfigReady = async () => {
            if (configReady) {
                const randomId = generateCodeVerifier()
                setCodeVerifier(randomId)
                const sha = await sha256(randomId)
                if (sha) {
                    setChallengeMethod('S256')
                    setCodeVerifierSha(sha)
                } else {
                    setChallengeMethod('plain')
                    setCodeVerifierSha(randomId)
                }
            }
        }

        fetchConfigReady()
    }, [configReady])

    useEffect(() => {
        if (codeVerifier && codeVerifierSha) {
            setCodeChallenge(base64UrlEncode(codeVerifierSha))
        }
    }, [codeVerifier, codeVerifierSha])

    useEffect(() => {
        if (codeChallenge) {
            const generatedUrl = `${config.authorization_endpoint}?protocol=oauth2&response_type=code&client_id=${VTCLOUD_CLIENT_ID}&redirect_uri=${PAGE_DOMAIN}iam/callback/viettel-cloud&state=${state}&code_challenge_method=${challengeMethod}&code_challenge=${codeChallenge}`
            setURL(generatedUrl)
            setURLReady(true)
            localStorage.setItem("checkEventPopupByUser", 1);
            if (props?.autoLogin) {
                window.location = generatedUrl
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [codeChallenge])

    useEffect(() => {
        if (urlReady && loginState) {
            updateSSOFlow({
                info: {
                    isProvideService: isProvideService === 'true',
                    code_verifier: codeVerifier,
                    redirect_uri: PAGE_DOMAIN + "iam/callback/viettel-cloud",
                },
            })
            setTimeout(() => {
                window.location = url
            }, 300)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlReady, loginState])

    return {
        url,
        urlReady,
        state,
        codeChallenge,
        login
    }

}

export default useViettelCloudIAM
